import Title from './Title';

const Plans = ({plans}) => {

      if(plans.length ===  0 || plans.data) return  

      return (
            <div className="main_xat__content">
                  <div className="container">
                        <Title title={'Xats And Days'} desc={'Amount And Prices'} />
                        <div className="main_table">
                              <table>
                                    <thead>
                                          <tr>
                                                <th>Plan</th>
                                                <th>Xats Amount</th>
                                                <th>Days Amount</th>
                                                <th>Only Xats</th>
                                                <th>Price</th>
                                          </tr>
                                    </thead>
                                    <tbody>
                                          {
                                                plans.map((item) => (
                                                      <tr key={item.title}>
                                                            <td><strong>{item.title}</strong></td>
                                                            <td>{item.xats}</td>
                                                            <td>{item.days}</td>
                                                            <td>{item.only_xats}</td>
                                                            <td><strong>$ {item.price}</strong></td>
                                                      </tr>
                                                ))
                                          }
                                    </tbody>
                              </table>
                        </div>
                  </div>
            </div>
      )
}

export default Plans;